import React, { FC } from 'react'
import { TagType } from 'types/tag'
import equal from 'fast-deep-equal'
import { Card, TagCard } from 'components/Card'

type Props = {
  tags: TagType[]
}

const TagCardList: FC<Props> = React.memo(
  (props) => {
    const { tags } = props

    return (
      <Card>
        {tags.map((tag) => (
          <TagCard key={tag.id} id={tag.id} isPublished={tag.is_published} name={tag.name} />
        ))}
      </Card>
    )
  },
  (prev, next) => equal(prev, next)
)

export default TagCardList
